export const HOME_FAQ = 'HOME_FAQ';
export const ALL_FAQS = 'ALL_FAQS';
export const INQUIRIES = 'INQUIRIES';

export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_LOADED = 'PAGE_LOADED';
export const ORDER_FORM = 'ORDER_FORM';
export const INVOLVED_IMAGES = 'INVOLVED_IMAGES';